/**
 * @fileoverview PUT handler for the "/:app_group_id/canvas_brief/:canvas_id" endpoint.
 * Uploads the brief file as multipart/form-data, replacing any existing brief.
 */
import fetch from "@lib/fetch";

import type { PutBriefResultErrors } from "../briefShared";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { canvasBriefCacheKeys } from "./constants";
import type { PutCanvasBriefProps, PutCanvasBriefResult } from "./types";

export const putCanvasBrief = reactQueryMutationAdapter(
  canvasBriefCacheKeys,
  createMutationFetcherFunctionWithShadowError<PutBriefResultErrors>()(
    (props: PutCanvasBriefProps): Promise<PutCanvasBriefResult> => {
      const body = new FormData();
      body.append("brief_file", props.briefFile);

      return fetch(
        `/${props.appGroupId}/canvas_brief/${props.canvasId}`,
        "PUT",
        {},
        { body },
        { setContentType: false, propagateFetchRequestError: false }
      );
    }
  )
);
